import { getRequest, postRequest } from "./https-axios.service";
import { getRuntimeEnv } from "./runtime-config";

const API_BASE_URL = getRuntimeEnv("REACT_APP_NEST_API_URL");
if (!API_BASE_URL) {
  throw new Error("REACT_APP_NEST_API_URL is not defined");
}
const BASE_URL = API_BASE_URL.replace(/\/$/, "");

export interface OtpSendResponse {
  ok: boolean;
  status:
    | "sent"
    | "rate_limited"
    | "locked"
    | "cooldown"
    | "no_match"
    | "multiple_matches"
    | "no_email";
  message: string;
  expiresInSeconds?: number;
  resendCooldownSeconds?: number;
  retryAfterSeconds?: number;
  lockRemainingSeconds?: number;
  maskedEmail?: string;
}

export interface OtpVerifyResponse {
  ok: boolean;
  status:
    | "verified"
    | "invalid_code"
    | "expired"
    | "locked"
    | "rate_limited"
    | "not_found"
    | "no_match"
    | "multiple_matches";
  message: string;
  market?: {
    haatBussID: string;
    businessName: string;
    partnerOwnerPhone: string;
    countryID?: string | null;
  };
  remainingAttempts?: number;
  lockRemainingSeconds?: number;
  retryAfterSeconds?: number;
}

async function sendOtp(phone: string, method: "sms" | "email" = "sms"): Promise<OtpSendResponse> {
  const { data } = await postRequest<OtpSendResponse>(`${BASE_URL}/auth/otp/send`, {
    phone,
    method,
  });
  return data;
}

async function resendOtp(phone: string, method: "sms" | "email" = "sms"): Promise<OtpSendResponse> {
  const { data } = await postRequest<OtpSendResponse>(
    `${BASE_URL}/auth/otp/resend`,
    {
      phone,
      method,
    },
  );
  return data;
}

async function verifyOtp(phone: string, code: string): Promise<OtpVerifyResponse> {
  const { data } = await postRequest<OtpVerifyResponse>(
    `${BASE_URL}/auth/otp/verify`,
    {
      phone,
      code,
    },
  );
  return data;
}

async function getProfile() {
  const { data } = await getRequest<any>(`${BASE_URL}/auth/profile`);
  return data;
}

async function logout() {
  const { data } = await postRequest<any>(`${BASE_URL}/auth/logout`, {});
  return data;
}

export const authService = {
  sendOtp,
  resendOtp,
  verifyOtp,
  getProfile,
  logout,
};
